export default {
  pdfData: null
}
